import { useSelector } from 'react-redux'

import {
  currentNumberSelector,
  currentTextSelector,
  lengthSelector,
} from '@/services/slices/questionSlice'
import QuestionCounter from '@/ui/QuestionCounter/QuestionCounter'
import classNames from 'classnames'

import styles from './QuestionCard.module.scss'

const QuestionCard = () => {
  const text = useSelector(currentTextSelector)
  const number = useSelector(currentNumberSelector)
  const questionsCount = useSelector(lengthSelector)

  return (
    <div className={styles.card}>
      <h1
        className={classNames(
          'text',
          't-caption-big',
          'text_color_tertiary',
          styles.heading,
        )}
      >
        Вопрос {number} из {questionsCount}
      </h1>

      <p
        className={classNames(
          'text',
          't-body-big',
          'text_color_primary',
          styles.text,
        )}
        dangerouslySetInnerHTML={{ __html: text }}
      />

      <QuestionCounter />
    </div>
  )
}

export default QuestionCard
